import React from 'react';
import { Typography } from 'antd';
import { brandSemantic } from '../config/brand';

const { Text } = Typography;

// Icon + label + value pill used in detail-page header strips (Internal Quote, Sales Quote/Order).
export default function InfoPill({ icon, label, value, accent }) {
  return (
    <div style={{
      border: `1px solid ${brandSemantic.border}`,
      borderRadius: 10,
      padding: '10px 14px',
      height: '100%',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 10,
      background: brandSemantic.surface,
    }}
    >
      <span style={{ color: brandSemantic.textSecondary, fontSize: 16, marginTop: 2 }}>{icon}</span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <Text style={{ display: 'block', fontSize: 10, fontWeight: 700, color: '#7A869A', letterSpacing: 0.3, textTransform: 'uppercase' }}>
          {label}
        </Text>
        <div style={{ marginTop: 2, fontWeight: 600, fontSize: 14, color: accent || brandSemantic.text, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
          {value}
        </div>
      </div>
    </div>
  );
}
